import { AnyIfEmpty } from 'react-redux';
import {
    GET_LOCATIONS_FAILURE,
    GET_LOCATIONS_REQUEST,
    GET_LOCATIONS_SUCCESS,
    ADD_LOCATION_FAILURE,
    ADD_LOCATION_REQUEST,
    ADD_LOCATION_SUCCESS,
    GET_LOCATION_BY_ID_FAILURE,
    GET_LOCATION_BY_ID_REQUEST,
    GET_LOCATION_BY_ID_SUCCESS,
    REMOVE_LOCATION_FAILURE,
    REMOVE_LOCATION_REQUEST,
    REMOVE_LOCATION_SUCCESS,
    ADD_TIME_REQUEST,
    ADD_TIME_SUCCESS,
    ADD_TIME_FAILURE,
    GET_TIME_ID_REQUEST,
    GET_TIME_ID_SUCCESS,
    GET_TIME_ID_FAILURE,
    EDIT_TIME_REQUEST,
    EDIT_TIME_SUCCESS,
    EDIT_TIME_FAILURE,
    CLEAR_PREVIOUS_LOCATION_DATA,
    IMPORT_PROPERTIES_REQUEST,
    IMPORT_PROPERTIES_SUCCESS,
    IMPORT_PROPERTIES_FAILURE,
    GET_LOCATION_DETAIL_BY_ID_FAILURE,
    GET_LOCATION_DETAIL_BY_ID_SUCCESS,
    GET_LOCATION_DETAIL_BY_ID_REQUEST,
    GET_OFFICE_HOURS_LOGS_REQUEST,
    GET_OFFICE_HOURS_LOGS_SUCCESS,
    GET_OFFICE_HOURS_LOGS_FAILURE,
    GET_LOCATION_AMENITIES_REQUEST,
    GET_LOCATION_AMENITIES_SUCCESS,
    GET_LOCATION_AMENITIES_FAILURE,
    CLEAR_LOCATION_AMENITIES,
    RESET_ERROR_MESSAGE,
} from '../constants/location.constants';

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
    location: {
        loading: false,
        data: [],
        errorMsg: '',
    },
    locationDetail: {
        loading: false,
        data: [],
        errorMsg: '',
    },
    officeHoursLogs: {
        loading: false,
        data: [],
        errorMsg: '',
    },
    amenities: {
        loading: false,
        data: [],
        errorMsg: '',
    },
};

const locationReducer = (state = initialState, action: { type: string; payload: AnyIfEmpty<object> }) => {
    switch (action.type) {
        //Import Properties

        case IMPORT_PROPERTIES_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
                errorMsg: '',
            };
        case IMPORT_PROPERTIES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case IMPORT_PROPERTIES_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        //Get locations

        case GET_LOCATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
                errorMsg: '',
            };
        case GET_LOCATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case GET_LOCATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        // Add location

        case RESET_ERROR_MESSAGE:
            return {
                ...state,
                errorMsg: '',
            };

        case ADD_LOCATION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ADD_LOCATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case ADD_LOCATION_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        // Get location by Id
        case GET_LOCATION_BY_ID_REQUEST:
            return {
                ...state,
                location: {
                    ...state.location,
                    loading: true,
                    // data: [],
                    // errorMsg: '',
                },
            };
        case GET_LOCATION_BY_ID_SUCCESS:
            return {
                ...state,
                location: {
                    ...state.location,
                    loading: false,
                    data: action.payload,
                },
            };
        case GET_LOCATION_BY_ID_FAILURE:
            return {
                ...state,
                location: {
                    ...state.location,
                    loading: false,
                    errorMsg: action.payload,
                },
            };

        /// add office time

        case ADD_TIME_REQUEST:
            return {
                ...state,
                loading: true,
                location: {
                    ...state.location,
                    loading: true,
                },
            };
        case ADD_TIME_SUCCESS:
            return {
                ...state,
                loading: false,
                location: {
                    ...state.location,
                    loading: false,
                    data: action.payload,
                },
            };
        case ADD_TIME_FAILURE:
            return {
                ...state,
                loading: false,
                location: {
                    ...state.location,
                    loading: false,
                    errorMsg: action.payload,
                },
            };

        //get office time by id

        case GET_TIME_ID_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_TIME_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case GET_TIME_ID_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        // edit office time

        case EDIT_TIME_REQUEST:
            return {
                ...state,
                loading: false,
            };
        case EDIT_TIME_SUCCESS:
            return {
                ...state,
                loading: false,
                // data: action.payload,
            };
        case EDIT_TIME_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        // Remove location
        case REMOVE_LOCATION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REMOVE_LOCATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                errorMsg: action.payload,
            };
        case REMOVE_LOCATION_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        case CLEAR_PREVIOUS_LOCATION_DATA:
            return {
                ...state,
                loading: false,
                location: {
                    ...state.location,
                    loading: false,
                    data: [],
                    errorMsg: '',
                },
            };

        case GET_LOCATION_DETAIL_BY_ID_REQUEST:
            return {
                ...state,
                locationDetail: {
                    ...state.locationDetail,
                    loading: true,
                },
            };
        case GET_LOCATION_DETAIL_BY_ID_SUCCESS:
            return {
                ...state,
                locationDetail: {
                    ...state.locationDetail,
                    loading: false,
                    data: action.payload,
                },
            };
        case GET_LOCATION_DETAIL_BY_ID_FAILURE:
            return {
                ...state,
                locationDetail: {
                    ...state.locationDetail,
                    loading: false,
                    errorMsg: action.payload,
                },
            };

        case GET_OFFICE_HOURS_LOGS_REQUEST:
            return {
                ...state,
                officeHoursLogs: {
                    loading: true,
                    data: [],
                    errorMsg: '',
                },
            };

        case GET_OFFICE_HOURS_LOGS_SUCCESS:
            return {
                ...state,
                officeHoursLogs: {
                    loading: false,
                    data: action.payload,
                    errorMsg: '',
                },
            };

        case GET_OFFICE_HOURS_LOGS_FAILURE:
            return {
                ...state,
                officeHoursLogs: {
                    loading: false,
                    data: [],
                    errorMsg: action.payload,
                },
            };

        case GET_LOCATION_AMENITIES_REQUEST:
            return {
                ...state,
                amenities: {
                    loading: true,
                    data: [],
                    errorMsg: '',
                },
            };

        case GET_LOCATION_AMENITIES_SUCCESS:
            return {
                ...state,
                amenities: {
                    loading: false,
                    data: action.payload,
                    errorMsg: '',
                },
            };

        case GET_LOCATION_AMENITIES_FAILURE:
            return {
                ...state,
                amenities: {
                    loading: false,
                    data: [],
                    errorMsg: action.payload,
                },
            };

        case CLEAR_LOCATION_AMENITIES:
            return {
                ...state,
                amenities: {
                    loading: false,
                    data: [],
                    errorMsg: '',
                },
            };

        default:
            return state;
    }
};

export default locationReducer;
